import React from "react";
import { ColorElement } from "../../../../../../../shared/ColorElement/ColorElement";
import {
  IGeometryOption,
  IOption,
  ISelectItemObjectData,
  optionObjectOptionT,
} from "../../../../../../../redux/reducers/ui/uiTypes";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../../redux/store";
import { getSelectOptionObjectDataByOptionId } from "../../../../../../../redux/reducers/ui/selectors/objectSelectors";
import { updateValueOptionSelectObjectAction } from "../../../../../../../redux/reducers/ui/actions/actions";

interface OptionDataI {
  variant: { id: number; image: string; name: string };
  option: IOption | IGeometryOption;
}

interface IProps {
  productId: string;
  type: optionObjectOptionT;
  proxyId: number;
  optionData: OptionDataI;
}
export const ObjectOptionGroupItem: React.FC<IProps> = props => {
  const { productId, type, proxyId, optionData } = props;
  const { variant, option } = optionData;
  const { id, image, name } = variant;
  const dispatch = useAppDispatch();
  const selectIdVariant = useAppSelector(
    // The selector expects (proxyId, optionId)
    getSelectOptionObjectDataByOptionId(productId, type)(proxyId, option.id)
  );

  const activeVariant = id === selectIdVariant;

  const handleChangeVariant = () => {
    const dataUpd: Partial<ISelectItemObjectData> = {};

    if (type === "material") {
      // enforce single option per proxy: clear other optionIds under this proxy
      dataUpd.materialOptions = {
        [proxyId]: {
          [option.id]: variant.id,
        },
      };
    }

    if (type === "geometry") {
      // enforce single option per proxy: clear other optionIds under this proxy
      dataUpd.geometryOptions = {
        [proxyId]: {
          [option.id]: variant.id,
        },
      };
    }
    dispatch(
      updateValueOptionSelectObjectAction({
        productId: productId,
        type: type,
        data: dataUpd,
      })
    );
  };

  return (
    <ColorElement
      img={image}
      onClick={handleChangeVariant}
      active={activeVariant}
      name={name}
    />
  );
};
